// import * as utils from './../libs/user-agent'
// import Preload from '../libs/preload-it'
import { MvSlide } from './swipter'

const DOM = {}
DOM.html = document.documentElement
DOM.loading = document.getElementById('js-loading')
DOM.bar = document.getElementById('js-bar')
DOM.mvslide = document.querySelector('.js-mv-slide')

/*
 * # ローディング
 */
window.addEventListener(
  'load',
  () => {
    if (!DOM.mvslide) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          DOM.bar.style.width = '100%'
          DOM.html.classList.add('complete')
          DOM.loading.classList.add('is-complete')
          DOM.loading.classList.add('is-complete')
        })
      })
    } else {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            DOM.bar.style.width = '100%'
            DOM.html.classList.add('complete')
            DOM.loading.classList.add('is-complete')

            setTimeout(() => {
              const swiper = new MvSlide(DOM.mvslide)
            }, 4000)
          }, 1000)
        })
      })
    }
  },
  false
)
